import { Icon } from '../../components/Icon'
import { useUi } from '../../state/ui'

/**
 * Starting a conversation: straight into New Message, which finds a person or a bot and offers a channel at its head.
 * It used to open a menu of "Direct message" and "New channel" first, but the first of those only opened this dialog
 * and the second is the row inside it, so the menu cost a tap to reach a choice the dialog already presents.
 */
export function NewConversationMenu({ compact = false }: { compact?: boolean }) {
  const openDialog = useUi((s) => s.openDialog)

  // On a phone it is an icon at the top beside the list's other controls: a floating button covered the rows.
  if (compact) {
    return (
      <button type="button" className="icon-button new-message-icon" aria-label="New message" title="New message" onClick={() => openDialog('new-dm')}>
        <Icon name="plus" />
      </button>
    )
  }
  return (
    <button type="button" className="button primary new-message" aria-label="New message" onClick={() => openDialog('new-dm')}>
      <Icon name="plus" />
      <span>New Message</span>
    </button>
  )
}
